import Programs from "pages/dashboard/shared/Programs/Programs";
import { FC } from "react";

interface SchoolProgramsProps {}

const SchoolPrograms: FC<SchoolProgramsProps> = () => {
  return <Programs />;
};
export default SchoolPrograms;
